import { Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-blog-custom-webdev',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './blog-custom-webdev.component.html',
  styleUrl: './blog-custom-webdev.component.scss'
})
export class BlogCustomWebdevComponent implements OnInit, OnDestroy {
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  @ViewChild('tableresponsiveImage') image!: ElementRef<HTMLImageElement>;

  originalWidth = 3502;
  originalHeight = 1020;

  nav(url: any) {
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/custom-web-development') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const customWebDevSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/custom-web-development#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/custom-web-development",
          "name": "Why Do You Need Custom Web Development: A Complete Guide | Kalpita Technologies",
          "description": "Complete guide to custom web development covering what it is, why businesses need it, how the development process works, and benefits.",
          "isPartOf": {
            "@type": "WebSite",
            "@id": "https://www.kalpitatechnologies.com/#website",
            "name": "Kalpita Technologies",
            "url": "https://www.kalpitatechnologies.com"
          },
          "inLanguage": "en"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/custom-web-development#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/blog", "name": "Blog Index" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/custom-web-development", "name": "Custom Web Dev Guide" } }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/custom-web-development#blogposting",
          "headline": "Why Do You Need Custom Web Development: A Complete Guide",
          "articleBody": "In the evolving technology world, building a powerful online presence is incredibly important. Current businesses are in search of new and creative ideas to engage with their target audience...",
          "author": { "@type": "Person", "name": "Grace Catharine" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "@id": "https://www.kalpitatechnologies.com/#organization"
          },
          "datePublished": "2024-03-29",
          "image": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/resources/blog/web-development/web-banner.webp" }
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/resources/kalpita-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(customWebDevSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  ngAfterViewInit(): void {
    this.resizeImageMap();
    if (this.image?.nativeElement) {
      this.image.nativeElement.onload = () => this.resizeImageMap();
    }
  }

  @HostListener('window:resize')
  resizeImageMap() {
    if (!this.image?.nativeElement) return;

    const img = this.image.nativeElement;
    const widthRatio = img.clientWidth / this.originalWidth;
    const heightRatio = img.clientHeight / this.originalHeight;

    document.querySelectorAll('map[name="table-image-map"] area').forEach((area: any) => {
      let coords = area.getAttribute('data-original-coords') || area.getAttribute('coords');
      if (!coords) return;

      area.setAttribute('data-original-coords', coords);
      const scaledCoords = coords.split(',').map((coord: any, index: number) =>
        Math.round(Number(coord) * (index % 2 === 0 ? widthRatio : heightRatio))
      );
      area.setAttribute('coords', scaledCoords.join(','));
    });
  }

  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }

  scrollToSection(sectionId: string): void {
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      const offset = 5 * 16;
      const scrollPosition = rect.top + window.pageYOffset - offset;
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }
  }
}
